import * as React from "react";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import {
  GlobalProvider,
  NavigationContext,
  NavTopBar,
  Nav,
  Footer,
} from "./components";
import { HomeRoot, ErrorPage } from "./pages";
import { Auth } from "aws-amplify";
import { useEffect } from "react";
import Callback from "./components/auth/Callback";

const RootApp: React.FC = () => {
  useEffect(() => {
    const checkUser = async () => {
      try {
        await Auth.currentAuthenticatedUser();
      } catch (err) {
        Auth.federatedSignIn();
      }
    };

    checkUser();
  }, []);

  return (
    <GlobalProvider>
      <Router>
        <div className="explo-app">
          <NavigationContext>
            <NavTopBar />
            <Nav />
          </NavigationContext>
          <div className="explo-app-container">
            <div className="main-content">
              <Switch>
                {/* HOME */}
                <Route path="/" component={HomeRoot} exact />
                <Route path="/callback" component={Callback} />
                <Route path="/401" component={ErrorPage} exact />
                <Redirect from="/index.html" to="/" />
                <Redirect from="*" to="/401" />
              </Switch>
            </div>
            <Footer />
          </div>
        </div>
      </Router>
    </GlobalProvider>
  );
};

export default RootApp;
